// 시공사례 저장 완료 문구 — 다른 편집기처럼 늘 「저장했습니다」, 서버가 덧붙인 안내(뺀 사진 등)가 있으면 뒤에 잇는다.
export const portfolioSavedMessage = (notice?: string): string => (notice ? `저장했습니다 — ${notice}` : "저장했습니다");
